module.exports = __webpack_public_path__ + "static/profileSimonB-4ea32366f5e4430776dab85655a7a3bf.jpg";